import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
// import { useEffect } from 'react';
import AC_GRID from '../../AutocodeTypes';
import TargetDefinitionDragableRow from './TargetDefinitionDragableRow';
import AutocodeCustomDragLayer from '../../AutocodeCustomDragLayer';
import ACDefinitionFolderDeleteModal from '../ACDefinitionFolderDeleteModal';
import { useACProjectContext } from '../../ACContext/ACDefinitionContext';
import { deleteDefinitions } from '../../../../actions/definitionActions';
import { AC_PERSONAL_FOLDER_SCOPE } from '../../AutocodeConstants';

const TargetDefinitionTableBody = ({
  allDefinitionTarget = null,
  selectDefination,
  handleDragEnd,
  selectedFolder,
  selectedWeightType,
}) => {
  const [defDelete, setDefDelete] = useState(null);

  const { moduleStudy, activeAccountId, defDataPoints } = useACProjectContext();

  const dispatch = useDispatch();

  const getSelectedEntries = () => {
    const selectedData = allDefinitionTarget.filter(i => i.checkState);
    return selectedData;
  };

  const _setDefDelete = item => {
    if (item) {
      const { expressionId, ovDefinitionId, title } = item;
      const obj = {
        expressionId,
        ovDefinitionId,
        title,
      };
      setDefDelete(obj);
    }
  };

  const keyHandler = event => {
    if (
      (event.key === 'Delete' &&
        defDataPoints.length > 1 &&
        selectedFolder.selectedFolder.scope ===
          AC_PERSONAL_FOLDER_SCOPE.value1) ||
      selectedFolder.selectedFolder.scope === AC_PERSONAL_FOLDER_SCOPE.value2
    ) {
      setDefDelete(defDataPoints);
    }
  };

  const deleteSingleDefinitions = defDelete => {
    const { expressionId, ovDefinitionId } = defDelete;
    const ssid = moduleStudy.ss === 'SIMMONS' ? 1 : 2;
    const accountId = activeAccountId;
    const definitionFolderId = ovDefinitionId;

    dispatch(
      deleteDefinitions({
        ssid,
        accountId,
        expressionId,
        definitionFolderId,
        moduleStudy,
        selectedWeightType,
      })
    );
  };

  const deleteDefinitionsData = defDelete => {
    if (defDelete && Boolean(defDelete.length)) {
      defDelete.forEach(item => {
        deleteSingleDefinitions(item);
      });
    } else {
      deleteSingleDefinitions(defDelete);
    }
  };

  return (
    <div
      className="ac--def--table__body "
      data-test="TargetDefinitionTableBody"
      onKeyDown={keyHandler}
    >
      <AutocodeCustomDragLayer
        items={getSelectedEntries()}
        type={AC_GRID.AC_DEFINITIONS}
      />
      {allDefinitionTarget.length > 0 &&
        allDefinitionTarget.map(data => (
          <div>
            <TargetDefinitionDragableRow
              allDefinitionTarget={allDefinitionTarget}
              data={data}
              handleDragEnd={handleDragEnd}
              selectedFolder={selectedFolder}
              onDelete={_setDefDelete}
              selectDefination={selectDefination}
            />
          </div>
        ))}
      {defDelete && (
        <ACDefinitionFolderDeleteModal
          folder={defDelete}
          show={defDelete !== null}
          closeHandler={() => setDefDelete(null)}
          deleteHandler={() => {
            deleteDefinitionsData(defDelete);
            setDefDelete(null);
          }}
        />
      )}
    </div>
  );
};

TargetDefinitionTableBody.propTypes = {
  allDefinitionTarget: PropTypes.shape({ data: PropTypes.shape([]) }),
  selectDefination: PropTypes.func,
  selectedFolder: PropTypes.shape({
    selectedFolder: {
      scope: PropTypes.number,
    },
  }),
  handleDragEnd: PropTypes.func,
  selectedWeightType: PropTypes.shape({}),
};
export default TargetDefinitionTableBody;
